import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {getCurrentUser} from "../../store/reducers/user/user.reducer";
import {clearPostContent, getPostData, setPostValue} from "../../store/reducers/posts/post.reducer";
import toast from "react-hot-toast";
import sendApiRequest, {NetworkMethods} from "../../lib/Network";
import SiteBreadCrumb from "../../components/page-breadcrumb/page-breadcrumb.component";
import Typography from "@mui/material/Typography";
import {getTinymce} from "@tinymce/tinymce-react/lib/es2015/main/ts/TinyMCE";
import SingleImageUpload from "../../components/input/single-image-upload.component";
import TextInputField from "../../components/input/text-input-field.component";
import DateInputField from "../../components/input/date-input-field.component";
import {Editor} from "@tinymce/tinymce-react";
import ActionButton from "../../components/button/button.component";
import AdvancedFileManager from "../../components/input/advanced-file-manager.component";

const handleImageItemClick = (url: string) => {
    let currentContent = getTinymce(window)?.activeEditor?.getContent() + "";
    currentContent += `<img src="${url}" alt="kep" width="300" height="300" style="object-fit: scale-down" />`
    getTinymce(window)?.activeEditor?.setContent(currentContent);
}

export default function PostCreate()
{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const editorRef: any = useRef("");

    const [isLoading, setIsLoading] = useState<boolean>();
    const [isOpenMediaManager, setIsOpenMediaManager] = useState<boolean>(false);

    const currentUser = useSelector(getCurrentUser);
    const postData = useSelector(getPostData);
    const { content, date, preview, title, slugTitle } = postData;

    const handlePreviewChange = (url: string) => dispatch(setPostValue("preview", url));
    const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => dispatch(setPostValue("title", event.target.value));
    const handleDateChange = (datestring: string) => dispatch(setPostValue("date", datestring));

    useEffect(() => {
        dispatch(clearPostContent());
    }, []);

    const onSubmit = async () => {
        try {
            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.POST,
                endpoint: `post/create`,
                payload: {
                    ...postData,
                    content: getTinymce(window)?.activeEditor?.getContent() + ""
                }
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a létrehozás közben! Indok: ${response?.error ?? "Nincs indok!"}`)
                return
            }

            toast.success("Sikeres létrehozás!");
            dispatch(clearPostContent());
            getTinymce(window)?.activeEditor?.setContent("");
        } catch (error: any) {
            toast.error(`Hiba a létrehozás közben! Indok: ${error?.message ?? "Nincs indok!"}`)
        }
    }

    if (isLoading)
    {
        return <div>
            Betöltés...
        </div>
    }

    return <div>
        <SiteBreadCrumb sites={[
            {
                name: "Főoldal",
                url: "/"
            },
            {
                name: "Posztok",
                url: "/posztok"
            },
            {
                name: "Létrehozás",
                url: "/letrehozas"
            },
        ]}/>
        <Typography variant='h3'>Bejegyzés varázsló</Typography>
        <br/>
        <br/>
        <Typography variant='h3'>Előkép szerkesztés</Typography>
        <br/>
        <SingleImageUpload value={preview} onChange={handlePreviewChange}/>
        <br/>
        <TextInputField title={"Bejegyzés címe"} value={title} onChange={handleTitleChange} fullWidth/>
        <DateInputField title={"Dátum"} value={new Date(date)} onChange={handleDateChange}/>
        <br/>
        <Typography variant='h3'>Tartalom megadása</Typography>
        <br/>
        <Editor
            apiKey='q6aeudc76f8tjyl69ll8d2i4wsw4sasm6yhd4fhvl7ko47ph'
            onInit={(_evt, editor) => editorRef.current = editor}
            initialValue={content}
            init={{
                height: 1300,
                menubar: false,
                language: 'hu_HU',
                plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                ],
                toolbar: 'undo redo | blocks | ' +
                    'bold italic forecolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | shortcuts',
                a11y_advanced_options: true,
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                setup: function (editor) {
                    editor.ui.registry.addMenuButton('shortcuts', {
                        tooltip: 'shortcuts',
                        icon: 'browse',

                        fetch: function (callback: any) {
                            const items = [
                                {
                                    type: 'menuitem',
                                    text: 'Fájl feltöltése',
                                    onAction: function () {
                                        setIsOpenMediaManager(!isOpenMediaManager);
                                    }
                                },
                            ];
                            callback(items);
                        }
                    });
                }
            }}
        />

        <br/>
        <br/>
        <ActionButton title="Bejegyzés létrehozása" type={"SAVE"} action={onSubmit}/>

        <AdvancedFileManager
            isOpen={isOpenMediaManager}
            handleClose={() => setIsOpenMediaManager(!isOpenMediaManager)}
            handleAudioFileSelection={() => {
            }}
            handleImageFileSelection={handleImageItemClick}
        />
    </div>
}